import $ from 'jquery'

let FIELD_TYPE = {
  ZIP: {
    pattern: /(^\d{5}$)/,
    selector: '.zip',
    msg: 'Postal code must be numeric and 5 characters long.'
  },
  PHONE: {
    pattern: /(^\d{10,15}$)/,
    selector: '.phone',
    msg: 'Phone must be numeric and 10 to 15 characters long.'
  },
  FAX: {
    pattern: /(^\d{10,15}$)/,
    selector: '.fax',
    msg: 'Fax must be numeric and 10 to 15 characters long.'
  }
}

/**
 * Validate the value of the field in the editor, if the field has
 * any one of the below class selectors.
 * class-selectors
 * ---------------
 * =>required
 * =>zip
 * =>phone
 * =>fax
 *
 */
function wireUpValidations (editor) {
  editor.on('preSubmit', function (e, o, action) {
    if (action !== 'remove') {
      // Iterate over all the fields in the form.
      $.map(editor.fields(), function (fieldName, i) {
        // Get a field instance the specified field name.
        let field = editor.field(fieldName)

        // Get the container of the field.
        let fieldContainer = $(field.node())

        // Required field validation.
        // Is this field a required field ?
        if (fieldContainer.find('.required').length > 0) {
          validateRequired(field, fieldContainer)
        }

        // Postal code validation.
        if (!field.inError()) {
          validatePattern(field, fieldContainer, FIELD_TYPE.ZIP)
        }

        // Phone Number validation.
        if (!field.inError()) {
          validatePattern(field, fieldContainer, FIELD_TYPE.PHONE)
        }

        // Fax Number validation.
        if (!field.inError()) {
          validatePattern(field, fieldContainer, FIELD_TYPE.FAX)
        }
      })

      // Is there any error in the form?
      if (this.inError()) {
        return false
      }
    }
  })
}

function validateEditorForm (action, editor) {
  if (action !== 'remove') {
    // Iterate over all the fields in the form.
    $.map(editor.fields(), function (fieldName, i) {
      // Get a field instance the specified field name.
      let field = editor.field(fieldName)

      // Get the container of the field.
      let fieldContainer = $(field.node())

      // Required field validation.
      // Is this field a required field ?
      if (fieldContainer.find('.required').length > 0) {
        validateRequired(field, fieldContainer)
      }

      // Postal code validation.
      if (!field.inError()) {
        validatePattern(field, fieldContainer, FIELD_TYPE.ZIP)
      }

      // Phone Number validation.
      if (!field.inError()) {
        validatePattern(field, fieldContainer, FIELD_TYPE.PHONE)
      }

      // Fax Number validation.
      if (!field.inError()) {
        validatePattern(field, fieldContainer, FIELD_TYPE.FAX)
      }
    })

    // Is there any error in the form?
    if (editor.inError()) {
      return false
    } else {
      return true
    }
  }
}

/**
 * If the input field has a 'required' class
 * selector then check whether the field value
 * is empty. If empty return error.
 *
 * @param field - Editor field instance.
 * @param fieldContainer - Container of the field.
 */
function validateRequired (field, fieldContainer) {
  // Is the field value empty ?
  if (!field.val()) {
    let label = $(fieldContainer).find('label').text()
    label = label.replace(':', '')
    field.error(label + ' is required.')
  }
}

/**
 * If the input field has a 'zip', 'phone' or 'fax' class
 * selector then check whether the field value
 * matches the pattern needed for the class selector.
 * If the value does not match the pattern, then
 * report error.
 *
 * @param field - Editor field instance.
 * @param fieldContainer - Container of the field.
 * @param fieldType - Either zip, phone or fax field type.
 */
function validatePattern (field, fieldContainer, fieldType) {
  let pattern = fieldType.pattern
  let selector = fieldType.selector
  let msg = fieldType.msg
  // If the field container contains a field with the specified selector then validate that field
  // for the specified pattern.
  if (fieldContainer.find(selector).length > 0) {
    if (field.val() && !pattern.test(field.val())) {
      field.error(msg)
    }
  }
}

export default {
  wireUpValidations: wireUpValidations,
  validateEditorForm: validateEditorForm
}



// WEBPACK FOOTER //
// ./src/js/common/DataTableEditorValidator.js